var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        "content-class": "no-overflow-x modal-aporte-resgate",
        "max-width": _vm.larguraModal,
        bus: _vm.busModal,
        persistent: "",
        "fixed-actions": ""
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("Title", {
                staticClass: "mb-4",
                attrs: {
                  title: _vm.tituloModal,
                  subtitle: _vm.cliente.name,
                  underlined: ""
                }
              })
            ]
          },
          proxy: true
        },
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _vm.mostrarCancelar
                ? _c(
                    "BaseButton",
                    { attrs: { underlined: "" }, on: { click: close } },
                    [_vm._v(" Cancelar ")]
                  )
                : _c(
                    "BaseButton",
                    {
                      attrs: { underlined: "" },
                      on: {
                        click: function($event) {
                          _vm.passoAtual = 1
                        }
                      }
                    },
                    [_vm._v(" Voltar ")]
                  ),
              _vm.passoAtual === 2
                ? _c(
                    "BaseButton",
                    {
                      attrs: { primary: "", loading: _vm.loadingSave },
                      on: {
                        click: function($event) {
                          return _vm.salvar(close)
                        }
                      }
                    },
                    [_vm._v(" Salvar ")]
                  )
                : _vm._e()
            ]
          }
        }
      ])
    },
    [
      _c(
        "div",
        { staticClass: "v-aplication" },
        [
          _vm.notaIa
            ? _c("AiGeneratedNote", {
                staticClass: "mb-6",
                attrs: { texto: _vm.notaIa }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "v-application" },
            [
              _c(
                "v-stepper",
                {
                  staticClass: "elevation-0 w-100",
                  model: {
                    value: _vm.passoAtual,
                    callback: function($$v) {
                      _vm.passoAtual = $$v
                    },
                    expression: "passoAtual"
                  }
                },
                [
                  _vm.mostrarStepper
                    ? _c(
                        "v-stepper-header",
                        { staticClass: "elevation-0" },
                        [
                          _c(
                            "v-stepper-step",
                            {
                              attrs: { editable: _vm.passoAtual > 1, step: "1" }
                            },
                            [_vm._v(" Escolha o ativo ")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: { editable: _vm.passoAtual > 2, step: "2" }
                            },
                            [_vm._v(" Adicione a movimentação ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-stepper-items",
                    { staticClass: "elevation-0" },
                    [
                      _c(
                        "v-stepper-content",
                        { staticClass: "pt-1 pb-0", attrs: { step: "1" } },
                        [
                          _vm.loading
                            ? _c(
                                "v-row",
                                {
                                  attrs: { justify: "center", align: "center" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "text-center ma-12 w-100" },
                                    [
                                      _c("v-progress-circular", {
                                        attrs: {
                                          size: 50,
                                          color: "primary",
                                          indeterminate: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                { staticClass: "col-12 pb-0" },
                                [
                                  _vm.passoAtual === 1
                                    ? _c("BaseTable", {
                                        class: {
                                          "modal-aporte-resgate__tabela--vazia": !_vm
                                            .tabelaAtivos.length
                                        },
                                        attrs: {
                                          "show-search": "",
                                          "external-search": "",
                                          "disable-margin-top": "",
                                          "search-placeholder":
                                            "Pesquisar ativo",
                                          "search-clearable": "",
                                          "search-value": _vm.search,
                                          height: "100%",
                                          "fixed-header": "",
                                          headers: _vm.cabecalhosAtivos,
                                          items: _vm.tabelaAtivos,
                                          "items-per-page": -1,
                                          "no-data-text": "",
                                          "hide-default-footer": ""
                                        },
                                        on: {
                                          "update:searchValue":
                                            _vm.definirBuscaAtivo,
                                          "click:row": _vm.escolherAtivo
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "item.pl_atual",
                                              fn: function(ref) {
                                                var item = ref.item
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-no-wrap"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.pl_atual)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            },
                                            {
                                              key: "item.acao",
                                              fn: function() {
                                                return [
                                                  _c("icon-svg", {
                                                    attrs: {
                                                      name: "mdi-chevron-right",
                                                      size: 18,
                                                      color: "#8E8E8E"
                                                    }
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    : _vm._e(),
                                  !_vm.tabelaAtivos.length
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "modal-aporte-resgate__vazio d-flex flex-column align-center justify-center az-gap"
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-sm text-color-900 mb-0"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.textoListaVazia) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _vm.search
                                            ? _c(
                                                "BaseButton",
                                                {
                                                  attrs: {
                                                    outline: "",
                                                    dark: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.search = ""
                                                    }
                                                  }
                                                },
                                                [_vm._v(" Limpar busca ")]
                                              )
                                            : _c(
                                                "BaseButton",
                                                {
                                                  attrs: { primary: "" },
                                                  on: {
                                                    click: _vm.openNewAsset
                                                  }
                                                },
                                                [_vm._v(" Cadastrar ativo ")]
                                              )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                        ],
                        1
                      ),
                      _c(
                        "v-stepper-content",
                        { staticClass: "pt-0", attrs: { step: "2" } },
                        [
                          _c(
                            "v-form",
                            { ref: "form" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex justify-center mb-5" },
                                [
                                  _c("BaseToggleButton", {
                                    attrs: {
                                      value: _vm.modo,
                                      options: _vm.opcoesModo,
                                      small: "",
                                      buttonStyle: "flatGray",
                                      role: "group",
                                      "aria-label": "Tipo de movimentação"
                                    },
                                    on: { input: _vm.selecionarModo }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "py-2",
                                      attrs: { cols: "12" }
                                    },
                                    [
                                      _c("input-by-type", {
                                        staticClass: "new-ux",
                                        attrs: {
                                          labelExternal: "Nome do ativo",
                                          outlined: "",
                                          disabled: ""
                                        },
                                        model: {
                                          value: _vm.edit.nome_ativo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.edit,
                                              "nome_ativo",
                                              $$v
                                            )
                                          },
                                          expression: "edit.nome_ativo"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm.modo === "Resgatar"
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "py-2",
                                          attrs: { cols: "12" }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "mt-0",
                                            attrs: {
                                              label: "Resgate total",
                                              "hide-details": ""
                                            },
                                            on: {
                                              change: _vm.changeResgateTotal
                                            },
                                            model: {
                                              value: _vm.edit.resgate_total,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.edit,
                                                  "resgate_total",
                                                  $$v
                                                )
                                              },
                                              expression: "edit.resgate_total"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "py-2",
                                      attrs: { cols: "6" }
                                    },
                                    [
                                      _c("input-by-type", {
                                        staticClass: "new-ux",
                                        attrs: {
                                          type: "date",
                                          labelExternal:
                                            _vm.rotuloDataAplicacao,
                                          placeholder: "DD/MM/AAAA",
                                          outlined: "",
                                          rules: [
                                            _vm.rules.data,
                                            _vm.rules.required,
                                            _vm.rules.maxDate
                                          ]
                                        },
                                        on: { input: _vm.coletarDataCotizacao },
                                        model: {
                                          value: _vm.edit.dataAplicacao,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.edit,
                                              "dataAplicacao",
                                              $$v
                                            )
                                          },
                                          expression: "edit.dataAplicacao"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "py-2",
                                      attrs: { cols: "6" }
                                    },
                                    [
                                      _c("input-by-type", {
                                        staticClass: "new-ux",
                                        attrs: {
                                          type: "date",
                                          labelExternal: "Data de cotização*",
                                          placeholder: "DD/MM/AAAA",
                                          outlined: "",
                                          rules: [
                                            _vm.rules.data,
                                            _vm.rules.minDateCotizacao
                                          ]
                                        },
                                        model: {
                                          value: _vm.edit.dataCotizacao,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.edit,
                                              "dataCotizacao",
                                              $$v
                                            )
                                          },
                                          expression: "edit.dataCotizacao"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm.isRF
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "py-2",
                                          attrs: { cols: "12" }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "mt-0",
                                            attrs: {
                                              label: "Marcar sempre na curva",
                                              dense: "",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value: _vm.edit.marcacao_curva,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.edit,
                                                  "marcacao_curva",
                                                  $$v
                                                )
                                              },
                                              expression: "edit.marcacao_curva"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.mostrarAplicacaoPor
                                    ? [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "py-2",
                                            attrs: {
                                              cols: _vm.colsAplicacaoPor
                                            }
                                          },
                                          [
                                            _c("input-by-type", {
                                              attrs: {
                                                type: "select",
                                                options: _vm.opcoesAplicacaoPor,
                                                labelExternal:
                                                  _vm.rotuloAplicacaoPor
                                              },
                                              model: {
                                                value: _vm.tab,
                                                callback: function($$v) {
                                                  _vm.tab = $$v
                                                },
                                                expression: "tab"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm.tab === "por-valor"
                                          ? _c(
                                              "v-col",
                                              {
                                                staticClass: "py-2",
                                                attrs: {
                                                  cols: _vm.colsCampoDependente
                                                }
                                              },
                                              [
                                                _c("input-by-type", {
                                                  staticClass: "new-ux",
                                                  attrs: {
                                                    type: _vm.moneyInputType,
                                                    labelExternal:
                                                      _vm.rotuloValor,
                                                    placeholder: "0,00",
                                                    outlined: ""
                                                  },
                                                  model: {
                                                    value: _vm.edit.valor,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.edit,
                                                        "valor",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "edit.valor"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.tab === "por-quantidade"
                                          ? [
                                              !_vm.edit.resgate_total
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-2",
                                                      attrs: {
                                                        cols:
                                                          _vm.colsCampoDependente
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "input-by-type",
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "new-ux",
                                                            attrs: {
                                                              type:
                                                                _vm.quantityInputType,
                                                              labelExternal:
                                                                "Quantidade*",
                                                              placeholder: "0",
                                                              outlined: ""
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.edit.qtd,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.edit,
                                                                  "qtd",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "edit.qtd"
                                                            }
                                                          },
                                                          "input-by-type",
                                                          _vm.quantityCurrencyProps,
                                                          false
                                                        )
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-2",
                                                  attrs: {
                                                    cols:
                                                      _vm.colsCampoDependente
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "input-by-type",
                                                    _vm._b(
                                                      {
                                                        staticClass: "new-ux",
                                                        attrs: {
                                                          type:
                                                            _vm.moneyInputType,
                                                          labelExternal:
                                                            _vm.rotuloPrecoUnitario,
                                                          placeholder: "0,00",
                                                          outlined: ""
                                                        },
                                                        model: {
                                                          value: _vm.edit.pu,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.edit,
                                                              "pu",
                                                              $$v
                                                            )
                                                          },
                                                          expression: "edit.pu"
                                                        }
                                                      },
                                                      "input-by-type",
                                                      _vm.puCurrencyProps,
                                                      false
                                                    )
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm.showPrecoCompra
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-2",
                                                      attrs: {
                                                        cols:
                                                          _vm.colsCampoDependente
                                                      }
                                                    },
                                                    [
                                                      _c("input-by-type", {
                                                        staticClass: "new-ux",
                                                        attrs: {
                                                          type:
                                                            _vm.moneyInputType,
                                                          decimalLength:
                                                            _vm.decimalLength,
                                                          labelExternal:
                                                            "Preço unitário de compra inicial*",
                                                          placeholder: "0,00",
                                                          outlined: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.edit
                                                              .preco_compra,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.edit,
                                                              "preco_compra",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "edit.preco_compra"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          : _vm._e()
                                      ]
                                    : _vm._e(),
                                  _vm.isRV
                                    ? [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "py-2",
                                            attrs: { cols: "4" }
                                          },
                                          [
                                            _c("input-by-type", {
                                              staticClass: "new-ux",
                                              attrs: {
                                                labelExternal: "Impostos",
                                                type: _vm.moneyInputType,
                                                placeholder: "0,00",
                                                outlined: ""
                                              },
                                              model: {
                                                value: _vm.edit.impostos,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.edit,
                                                    "impostos",
                                                    $$v
                                                  )
                                                },
                                                expression: "edit.impostos"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "py-2",
                                            attrs: { cols: "4" }
                                          },
                                          [
                                            _c("input-by-type", {
                                              staticClass: "new-ux",
                                              attrs: {
                                                labelExternal: "Taxas",
                                                type: _vm.moneyInputType,
                                                placeholder: "0,00",
                                                outlined: ""
                                              },
                                              model: {
                                                value: _vm.edit.taxas,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.edit,
                                                    "taxas",
                                                    $$v
                                                  )
                                                },
                                                expression: "edit.taxas"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm.isOffshore
                                          ? _c(
                                              "v-col",
                                              {
                                                staticClass: "py-2",
                                                attrs: { cols: "4" }
                                              },
                                              [
                                                _c("input-by-type", {
                                                  staticClass: "new-ux",
                                                  attrs: {
                                                    labelExternal: "Câmbio",
                                                    type: "money",
                                                    placeholder: "0,00",
                                                    outlined: ""
                                                  },
                                                  model: {
                                                    value: _vm.edit.cotacao,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.edit,
                                                        "cotacao",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "edit.cotacao"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _c(
                                "div",
                                { staticClass: "text-xs text-color-900 mt-5" },
                                [
                                  _vm._v(
                                    " Saldo em conta: " +
                                      _vm._s(_vm.saldoFormatado) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.mostrarCamposObrigatorios
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-xs text-color-900 modal-aporte-resgate__obrigatorios"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("* Campos obrigatórios")
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }